<div class="container detail detailTableauModif" *ngIf="!isEmpty" (click)="common.outSide($event, true, true)">
  <div class="header col-sm-12">
    <div class="col-sm-6">
      <h2 *ngIf="!add"> {{ detail.isHisto ? 'Visualiser' : 'Modifier ' }} le devis N° {{ detail.numDevis }} </h2>
      <h2 *ngIf="add"> Création d'un devis </h2>
      <strong *ngIf="detail.client && detail.client.id"
        [ngStyle]="{'color': common.getCodeBlocage(detail.client.codeBlocage) !== '' ? '#FF0000' : '#000'}"> {{
        detail.client ? ((detail.client.prospect ? (detail.client.codeProspect || '') :
        (detail.client.codeClient || '')) + ' / ' + (detail.client.nomClient || '')) :
        '' }} {{common.getCodeBlocage(detail.client.codeBlocage) !== '' ? ('(' +
        common.getCodeBlocage(detail.client.codeBlocage) + ')') : ''}} </strong>
      <label class="text-left uppercase text-underline historique" (click)="showFiche()">Voir la fiche</label>
    </div>
    <div class="col-sm-6 text-right">
      <div class="btn-group dropdown-valider-devis" *ngIf="!isDepuisFacturation" dropdown style="margin-right: 5px">
        <button id="button-basic" dropdownToggle type="button" class="btn-header uppercase  dropdown-toggle"
          aria-controls="dropdown-basic">
          Imprimer
        </button>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-more menuImp" role="menu">
          <li role="menuitem">
            <button class="bouton btn-simple uppercase" (click)="getFormatperso()">Imprimer</button>
          </li>
          <li role="menuitem"
            *ngIf="!isDesactiverFormatStandardCAP && societe.isEcoDD &&  detail.client && detail.client.id && !detail.client.prospect && !societe.isFIPCET">
            <button class="bouton btn-simple uppercase" (click)="imprimeCAP(true)">Imprimer CAP</button>
          </li>
          <!--<li role="menuitem"
            *ngIf="societe.isEcoDD && detail.client && detail.client.id && !detail.client.prospect && !societe.isFIPCET">
            <button class="bouton btn-simple uppercase" (click)="imprimeCAP(true)">Imprimer CAP FP</button>
          </li> -->
          <li role="menuitem">
            <button class="bouton btn-simple uppercase" (click)="initialiserEnvoiParMail()">Envoyer par
              mail
            </button>
          </li>
        </ul>
      </div>
      <button *ngIf="detail.isHisto && !isDepuisFacturation && isDroitCreerDevis" class="btn-header uppercase uppercase"
        (click)="ouvrirDialogueDupliquer()" style="margin-right: 5px">Dupliquer
      </button>

      <div *ngIf="!detail.isHisto && !isDepuisFacturation" class="btn-group dropdown-valider-devis" dropdown
        style="margin-right: 5px">
        <button id="button-basic" dropdownToggle type="button" class="btn-header uppercase  dropdown-toggle"
          aria-controls="dropdown-basic" style="width: 65px">
          ...
        </button>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-more menuImp" role="menu">
          <li *ngIf="isDroitCreerDevis" role="menuitem">
            <button class="bouton btn-simple uppercase" (click)="ouvrirDialogueDupliquer()">Dupliquer
            </button>
          </li>
          <li role="menuitem" *ngIf="!add && isDroitHistoDevis && !isClientBloquer" style="margin: 2px 0;">
            <!-- acceptationDevisFIP() -->
            <button class="bouton btn-simple uppercase" (click)="disabledAccepterBtnHandle();avantAcceptDevisFIP();"
              [disabled]="disabledAccepterBtn">Accepter
            </button>
          </li>
          <li role="menuitem" *ngIf="!add && isDroitHistoDevis">
            <button class="bouton btn-simple uppercase" (click)="ouvrirDialogueRefuser()">Refuser</button>
          </li>
          <li *ngIf="isDroitModifDevis" role="menuitem">
            <button class="bouton btn-simple uppercase" (click)="returnList()"> ANNULER LES MODIFICATIONS
            </button>
          </li>
        </ul>
      </div>

      <button *ngIf="!isDepuisFacturation && !detail.isHisto" class="btn-header uppercase actionPricipal" id="close3"
        (click)="isDroitModifDevis ? (add ? createDevis(true, true) : (isEdit ? updateDevis(detail): returnList())) : returnList()">
        {{ isDroitModifDevis ? 'Enregistrer' : 'Fermer' }}
      </button>

      <button class="btn-header uppercase actionPricipal" id="close3" (click)="returnList()">
        Fermer
      </button>
      <!--button class="btn-header uppercase" (click)="returnList()" [ngClass]="{'actionPricipal': !isEdit}"> Fermer
      </button-->
      <div [ngClass]="{'disabledbutton': add || !detail.id}">
        <label class="text-left uppercase text-underline historique"
          (click)="common.getLogs(detail.id, '45', modalService);">
          Voir l'historique </label>
        <label class="text-left uppercase text-underline historique"
          (click)="common.getDocument(detail.id || 0, modalService, 1,true)">Voir
          les documents</label>
      </div>
    </div>
  </div>

  <div class="headerBon col-sm-12" *ngIf="!viewFull" id="headerBon">
    <div class="row headerDevis" [ngClass]="{'disabledbutton': isDepuisFacturation}">
      <div class="col-sm-2">
        <div class="row divedit" (click)="editChamp('date', $event)" [ngClass]="{'div': !detail.isHisto}">
          <label class="col-sm-12"> Date </label>
          <div class="col-sm-12" *ngIf="!isEditChp.date"> {{ detail.dateCreation }} </div>
          <div class="col-sm-12" *ngIf="isEditChp.date">
            <app-input-date [class]="'form-control input-simple'" id="date" [dateVide]="true"
              [model]="detail.dateCreationModel"
              (changefct)="detail.dateCreationModel = $event; changeDateModel($event, 'dateCreation')"
              (keyenterfct)="editChamp('date')" [disable]="detail.isHisto || !isDroitModifDevis">
            </app-input-date>
          </div>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="col-sm-11 divedit" style="padding: 0; margin-left: -15px;" (click)="editChamp('datevalid', $event)"
          [ngClass]="{'div': !detail.isHisto}">
          <label class="col-sm-12"> Fin Validité </label>
          <div class="col-sm-12" *ngIf="!isEditChp.datevalid"> {{ detail.dateFinValidite ?
            detail.dateFinValidite : ''}} </div>
          <div class="col-sm-12" *ngIf="isEditChp.datevalid">
            <app-input-date [class]="'form-control input-simple'" id="date" [dateVide]="true"
              [model]="detail.dateFinValiditeModel" (changefct)="changeDateModel($event, 'dateFinValidite')"
              (keyenterfct)="editChamp('datevalid')" [disable]="detail.isHisto || !isDroitModifDevis">
            </app-input-date>
          </div>
        </div>

        <div class="col-sm-1" style="padding: 0">
          <button class="btn-detail" style="padding: 0" (click)="copieDateDevis(cht)"
            popover="Dupliquer les dates sur les lignes" placement="bottom" [container]="'body'"
            [containerClass]="'contenantPopoevr'" [notDebounce]="true" triggers="mouseenter:mouseleave"
            [disabled]="!isDroitModifDevis">
            <i class="fa fa-copy"></i>
          </button>
        </div>

      </div>

      <div class="col-sm-2">
        <div class="row divedit" (click)="(!detail.isHisto && isDroitModifDevis) ? editChamp('contact', $event) : false"
          [ngClass]="{'div': !detail.isHisto}">
          <label class="col-sm-12"> Contact </label>
          <div class="col-sm-12" *ngIf="!isEditChp.contact">
            {{ detail.contact ? (detail.contact.libelleObjetEntite ? detail.contact.libelleObjetEntite :
            (detail.contact.nom + ' ' + detail.contact.prenom)) : '' }}
          </div>
          <div class="col-sm-12" *ngIf="isEditChp.contact" style="padding: 0">
            <div class="col-sm-12" *ngIf="isEditChp.contact" style="padding: 0">
              <div class="" style="padding: 0px;"
                [ngClass]="{'col-sm-8': detail.contact, 'col-sm-10': !detail.contact}">
                <app-autocomplete [placeholder]="''" [active]="detail.isHisto" (searchfunction)="searchContact($event)"
                  (selectfunction)="detail.contact = $event; reloadContact($event.id); isEdit = true;isEditChp.contact = false;"
                  [results]="dataContact" (keyenterfunction)="isEditChp.contact = false;" [highlight]="true"
                  [label]="''" [dropdownclass]="mindropdown" [selectvalue]="true" [autoshow]="true"
                  [id]="'modedepaie contact'" [defaultselected]="detail.contact" [defaultsearch]="''">
                </app-autocomplete>
              </div>

              <div class="text-right" style="padding: 5px 0px;"
                [ngClass]="{'col-sm-4': detail.contact, 'col-sm-2': !detail.contact}">
                <button class="btn-add minbtn" id="modif" *ngIf="detail.contact"
                  (click)="isAddContact = false;showFicheContact()">
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                </button>
                <button class="btn-add minbtn activebtn" id="add" (click)="isAddContact = true;showFicheContact()">
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="row divedit" (click)="(!detail.isHisto && isDroitModifDevis) ? editChamp('user', $event) : false"
          [ngClass]="{'div': !detail.isHisto}">
          <label class="col-sm-12"> Commercial </label>
          <div class="col-sm-12" *ngIf="!isEditChp.user">
            {{ detail.user ? (detail.user.libelleObjetEntite ? detail.user.libelleObjetEntite : ((detail.user.prenom ||
            '') + ' ' + (detail.user.nom || '')) ) : '' }}
          </div>
          <div class="col-sm-12" *ngIf="isEditChp.user">
            <app-autocomplete [placeholder]="''" [active]="detail.isHisto" (searchfunction)="searchCommercial($event)"
              (selectfunction)="detail.user = $event; isEdit = true;isEditChp.user = false;" [results]="listUser"
              (keyenterfunction)="isEditChp.user = false;" [highlight]="true" [label]="''" [dropdownclass]="mindropdown"
              [selectvalue]="true" [autoshow]="true" [id]="'modedepaie user'" [defaultselected]="detail.user"
              [defaultsearch]="detail.user ? detail.user.libelleObjetEntite || detail.user.nom : ''"></app-autocomplete>
          </div>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="row divedit"
          (click)="(!detail.isHisto && isDroitModifDevis) ? editChamp('motifCreationDevis', $event) : false"
          [ngClass]="{'div': !detail.isHisto}">
          <label class="col-sm-12"> Motif création </label>
          <div class="col-sm-12" *ngIf="!isEditChp.motifCreationDevis">
            {{ detail.motifCreationDevis ? (detail.motifCreationDevis.libelle ||
            detail.motifCreationDevis.libelleObjetEntite) : (motifCreationDevis || '') }}
          </div>
          <div class="col-sm-12" *ngIf="isEditChp.motifCreationDevis">
            <app-autocomplete [placeholder]="''" [active]="detail.isHisto"
              (searchfunction)="searchMotifCreationDevis($event)"
              (selectfunction)="detail.motifCreationDevis = $event; isEdit = true;isEditChp.motifCreationDevis = false; motifCreationDevis = detail.motifCreationDevis.libelle"
              [results]="dataMotifCreationDevis" (keyenterfunction)="isEditChp.motifCreationDevis = false;"
              [highlight]="true" [label]="''" [dropdownclass]="mindropdown" [selectvalue]="true" [autoshow]="true"
              [id]="'modedepaie motifCreationDevis'" [defaultselected]="detail.motifCreationDevis"
              [defaultsearch]="detail.motifCreationDevis ? (detail.motifCreationDevis.libelle || detail.motifCreationDevis.libelleObjetEntite) : (motifCreationDevis || '')">
            </app-autocomplete>
          </div>
        </div>
      </div>

      <div class="col-sm-2" [ngClass]="{'disabledbutton': detail && detail.zone && detail.zone.id }">
        <div class="row divedit"
          (click)="(!detail.isHisto && isDroitModifDevis) ? editChamp('chantier', $event) : false"
          [ngClass]="{'div': !detail.isHisto}">
          <label class="col-sm-12"> Chantier </label>
          <div class="col-sm-12" *ngIf="!isEditChp.chantier || (detail && detail.zone && detail.zone.id)">
            {{ detail.chantier && detail.chantier.id ? getLibelleChantier(detail.chantier) : 'Tous' }}
          </div>
          <div class="col-sm-12" *ngIf="isEditChp.chantier && !(detail && detail.zone && detail.zone.id)"
            style="padding: 0 3px 0 0;">
            <div class="col-sm-12" *ngIf="isEditChp.chantier && !(detail && detail.zone && detail.zone.id)"
              style="padding: 0">
              <div class="" style="padding: 0px;"
                [ngClass]="{'col-sm-8': detail.chantier, 'col-sm-10': !detail.chantier}">
                <app-autocomplete [placeholder]="''" (searchfunction)="searchChantier($event)"
                  (selectfunction)="getDetailChantier($event, true); isEdit = true;isEditChp.chantier = false;"
                  [results]="listChantier" (keyenterfunction)="isEditChp.chantier = false;" [highlight]="true"
                  [label]="''" [dropdownclass]="'mindropdown devisdropdown'" [selectvalue]="true" [autoshow]="true"
                  [positionDropdown]="'right'" [id]="'modedepaie chantier '"
                  [defaultselected]="detail.chantier ? detail.chantier.numChantier : ''"
                  [defaultsearch]="detail.chantier ? detail.chantier.numChantier : ''">
                </app-autocomplete>
              </div>

              <div class="text-right" style="padding: 5px 0px;"
                [ngClass]="{'col-sm-4': detail.chantier, 'col-sm-2': !detail.chantier}">
                <button class="btn-add minbtn" id="modif" *ngIf="detail.chantier"
                  [disabled]="detail && detail.zone && detail.zone.id" (click)="getDetailChantier(detail.chantier)">
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                </button>
                <button class="btn-add minbtn activebtn" id="add" (click)="addChantier()"
                  [disabled]="detail && detail.zone && detail.zone.id">
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Seconde rangée -->
    <div class="row headerDevis" [ngClass]="{'disabledbutton': isDepuisFacturation}">
      <div class="col-sm-2">
        <div class="row divedit"
          (click)="(!detail.isHisto && isDroitModifDevis) ? editChamp('sitePrest', $event) : false"
          [ngClass]="{'div': !detail.isHisto}">
          <label class="col-sm-12"> Site Prestation</label>
          <div class="col-sm-12" *ngIf="!isEditChp.sitePrest">
            {{ detail.sitePrest ? detail.sitePrest.nom : '' }}
          </div>
          <div class="col-sm-12" *ngIf="isEditChp.sitePrest">
            <app-autocomplete [placeholder]="''" [active]="detail.isHisto" (searchfunction)="searchSite($event)"
              (selectfunction)="detail.sitePrest = $event; isEdit = true;isEditChp.sitePrest = false;"
              [results]="result" (keyenterfunction)="isEditChp.sitePrest = false;" [highlight]="true" [label]="''"
              [dropdownclass]="mindropdown" [selectvalue]="true" [isCombo]="true" [id]="'modedepaie sitePrest'"
              [defaultselected]="detail.sitePrest" [defaultsearch]="detail.sitePrest ? detail.sitePrest.nom : ''">
            </app-autocomplete>
          </div>
        </div>
      </div>
      <div class="col-sm-2">
        <div class="row divedit" (click)="(!detail.isHisto && isDroitModifDevis) ? editChamp('remise', $event) : false"
          [ngClass]="{'div': !detail.isHisto}">
          <label class="col-sm-12"> Remise </label>
          <div class="col-sm-12" *ngIf="!isEditChp.remise">
            {{detail.pourcentageRemise ? toFixed(detail.pourcentageRemise) : default.toFixed(nbdigit)}} {{
            detail.pourcentageRemiseEuro
            ? devise : '%' }}
          </div>
          <div class="col-sm-12" *ngIf="isEditChp.remise">
            <div class="input-group col-sm-12">
              <input type="text" class="form-control" id="remise" style=" width: calc(100% - 50px);"
                (keyup.enter)="editChamp('remise')" [(ngModel)]="detail.pourcentageRemise" (ngModelChange)="getPrix()"
                [disabled]="detail.isImprimee || detail.isReglee || !isDroitModifDevis">
              <!-- ne fonctionne plus
                <div class="input-group-append">
                    <button class="btn-remise drop dropdown-toggle" id="btnremise" type="button" data-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      {{ detail.pourcentageRemiseEuro ? devise : '%' }}
                      <i class="fa fa-angle-down" style="font-size: 12px;"></i>
                    </button>
                    <div class="dropdown-menu" style="min-width: 125px; margin-top: 0px;">
                        <p class="dropdown-item" (click)="detail.pourcentageRemiseEuro = false; getPrix();">
                          % </p>
                        <div role="separator" class="dropdown-divider"></div>
                        <p class="dropdown-item" (click)="detail.pourcentageRemiseEuro = true; getPrix();">
                          {{ devise }} </p>
                    </div>
                </div>
                -->

              <div class="input-group-append container-pourcentage-euro-remise-devis" dropdown>
                <button id="button-basic" dropdownToggle type="button" class="btn-remise btn-primary dropdown-toggle"
                  aria-controls="dropdown-basic"
                  [disabled]="detail.isImprimee || detail.isReglee || !isDroitModifDevis">
                  {{ detail.pourcentageRemiseEuro ? devise : '%' }} <span class="caret"></span>
                </button>
                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                  <li role="menuitem">
                    <a class="dropdown-item" (click)="detail.pourcentageRemiseEuro = false; getPrix();">%</a>
                  </li>
                  <li role="menuitem">
                    <a class="dropdown-item" (click)="detail.pourcentageRemiseEuro = true; getPrix();">{{ devise }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-2">
        <div class="row divedit" (click)="!detail.isHisto ? editChamp('titre', $event) : false"
          [ngClass]="{'div': !detail.isHisto}">
          <label class="col-sm-12"> Titre </label>
          <div class="col-sm-12" *ngIf="!isEditChp.titre"> {{ detail.titre}} </div>
          <div class="col-sm-12" *ngIf="isEditChp.titre">
            <input type="text" class="form-control" autofocus id="titre" [(ngModel)]="detail.titre"
              (ngModelChange)="isEdit=true;" (keyup.enter)="editChamp('titre')"
              [disabled]="detail.isHisto || !isDroitModifDevis">
          </div>
        </div>
      </div>
      <div class="col-sm-2" *ngIf="detail.isHisto && detail.motifRefus">
        <div class="row divedit">
          <label class="col-sm-12"> Motif refus </label>
          <div class="col-sm-12">
            {{ detail.motifRefus ? (detail.motifRefus.libelle || detail.motifRefus.libelleObjetEntite) : ('') }}
          </div>

        </div>
      </div>
      <div class="col-sm-2" *ngIf="listSection && listSection.length">
        <div class="row ">
          <label class="col-sm-12"> Section </label>
          <div class="col-sm-12">
            <mat-checkbox [color]="'primary'" [(ngModel)]="detail.lignesParSection"
              (ngModelChange)="changeLigneParSection()"></mat-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div class="row headerDevis">
      <span class="uppercase text-underline historique showmore" (click)="showMore = !showMore;">
        {{showMore ? 'Masquer les détails' : 'Afficher plus de détail'}}
      </span>

      <span class="uppercase text-underline historique showmore" (click)="prixNego = !prixNego;">
        Consulter les prix négociés du client
      </span>
    </div>

    <!-- 3ème rangée -->
    <div class="row headerDevis" *ngIf="showMore" [ngClass]="{'disabledbutton': isDepuisFacturation}">


      <div class="col-sm-2">
        <div class="row divedit" (click)="editChamp('datePrevisionnelle', $event)" [ngClass]="{'div': !detail.isHisto}">
          <label class="col-sm-12"> Date prévisionnelle</label>
          <div class="col-sm-12" *ngIf="!isEditChp.datePrevisionnelle"> {{ detail.datePrevisionnelle ?
            detail.datePrevisionnelle : ''}} </div>
          <div class="col-sm-12" *ngIf="isEditChp.datePrevisionnelle">
            <app-input-date [class]="'form-control input-simple'" id="date" [dateVide]="true"
              [model]="detail.datePrevisionnelleModel" (changefct)="changeDateModel($event, 'datePrevisionnelle')"
              (keyenterfct)="editChamp('datePrevisionnelle')" [disable]="detail.isHisto || !isDroitModifDevis">
            </app-input-date>
          </div>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="row divedit" (click)="editChamp('dateAcceptation', $event)" [ngClass]="{'div': !detail.isHisto}">
          <label class="col-sm-12"> Date acceptation </label>
          <div class="col-sm-12" *ngIf="!isEditChp.dateAcceptation"> {{ detail.dateAcceptation }} </div>
          <div class="col-sm-12" *ngIf="isEditChp.dateAcceptation">
            <app-input-date [class]="'form-control input-simple'" id="date" [dateVide]="true"
              [model]="detail.dateAcceptationModel" (changefct)="changeDateModel($event, 'dateAcceptation')"
              (keyenterfct)="editChamp('dateAcceptation')" [disable]="detail.isHisto || !isDroitModifDevis">
            </app-input-date>
          </div>
        </div>
      </div>

      <div class="col-sm-2"
        [ngClass]="{'disabledbutton': detail && detail.chantier && detail.chantier.zone && detail.chantier.zone.id }">
        <div class="row divedit" (click)="editChamp('zone', $event)" [ngClass]="{'div': !detail.isHisto}">
          <label class="col-sm-12"> Zone ciblé </label>
          <div class="col-sm-12" *ngIf="!isEditChp.zone"> {{ detail.zone ? detail.zone.libelle : 'Toutes' }} </div>
          <div class="col-sm-12"
            *ngIf="isEditChp.zone && !( detail && detail.chantier && detail.chantier.zone && detail.chantier.zone.id )">
            <!-- <select class="col-sm-12 form-control" [(ngModel)]="detail.zone" style="margin-bottom: 15px;"
              (ngModelChange)="editChamp('zone');" [disabled]="!isDroitModifDevis">
              <option *ngFor="let zone of listeZone" [ngValue]="zone"> {{ zone.libelle }} </option>
            </select> -->
            <app-autocomplete [placeholder]="''"
              (selectfunction)="detail.zone = $event; editChamp('zone'); isEdit = true;isEditChp.zone = false;"
              [results]="listeZone" (keyenterfunction)="isEditChp.zone = false;" [highlight]="true" [label]="''"
              [dropdownclass]="'mindropdown devisdropdown'" [isCombo]="true" [id]="'modedepaie zone '"
              [defaultselected]="detail.zone" [defaultsearch]="detail.zone ? detail.zone.libelle : ''">
            </app-autocomplete>
          </div>
        </div>
      </div>
      <div class="col-sm-2">
        <div class="row divedit" (click)="!detail.isHisto ? editChamp('siteCA', $event) : false"
          [ngClass]="{'div': !detail.isHisto}">
          <label class="col-sm-12"> Site CA</label>
          <div class="col-sm-12" *ngIf="!isEditChp.siteCA">
            {{ detail.siteCA ? detail.siteCA.nom : '' }}
          </div>
          <div class="col-sm-12" *ngIf="isEditChp.siteCA">
            <app-autocomplete [placeholder]="''" [active]="detail.isHisto || !isDroitModifDevis"
              (searchfunction)="searchSite($event)"
              (selectfunction)="detail.siteCA = $event; isEdit = true;isEditChp.siteCA = false;" [results]="result"
              (keyenterfunction)="isEditChp.siteCA = false;" [highlight]="true" [label]="''"
              [dropdownclass]="mindropdown" [selectvalue]="true" [isCombo]="true" [id]="'modedepaie siteCA'"
              [defaultselected]="detail.siteCA" [defaultsearch]="detail.siteCA ? detail.siteCA.nom : ''">
            </app-autocomplete>
          </div>
        </div>
      </div>
      <div class="col-sm-2">
        <div class="row divedit" (click)="!detail.isHisto ? editChamp('numeroAffaireManuel', $event) : false"
          [ngClass]="{'div': !detail.isHisto}">
          <label class="col-sm-12"> Numéro affaire manuel </label>
          <div class="col-sm-12" *ngIf="!isEditChp.numeroAffaireManuel"> {{ detail.numeroAffaireManuel ?
            detail.numeroAffaireManuel : "" }} </div>
          <div class="col-sm-12" *ngIf="isEditChp.numeroAffaireManuel">
            <input type="text" class="form-control" autofocus id="numeroAffaireManuel"
              [(ngModel)]="detail.numeroAffaireManuel" (ngModelChange)="isEdit=true;"
              (keyup.enter)="editChamp('numeroAffaireManuel')" [disabled]="detail.isHisto || !isDroitModifDevis">
          </div>
        </div>
      </div>

      <div class="col-sm-2" *ngIf="isGestionAffaire">
        <div class="row divedit" (click)="editChamp('affaire', $event)" [ngClass]="{'div': !detail.isHisto}">
          <label class="col-sm-12"> Affaire </label>
          <div class="col-sm-12" *ngIf="!isEditChp.affaire && detail.affaire"> {{ detail.affaire.numAffaire
            }} </div>
          <div class="col-sm-12" *ngIf="isEditChp.affaire">
            <select class="col-sm-12 form-control" [(ngModel)]="detail.affaire" style="margin-bottom: 15px;"
              (ngModelChange)="editChamp('affaire');" [disabled]="!isDroitModifDevis">
              <option *ngFor="let affaire of listeAffaire" [ngValue]="affaire"> {{ affaire.numAffaire }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="ligneBon listedevis col-sm-12 tablewithSelect"
    [ngStyle]="{'height': showMore ? 'calc(100% - 325px)' : 'calc(100% - ' + calcHeightDatatable() + 'px)'}">
    <mat-tab-group class="sectionChecked" *ngIf="detail.lignesParSection" animationDuration="0ms"
      (selectedTabChange)="tabChanged($event)">
      <ng-template ngFor let-index="index" let-section [ngForOf]="listSection">
        <mat-tab>
          <ng-template mat-tab-label>
            {{ section.libelleObjetEntite }}
          </ng-template>
        </mat-tab>
      </ng-template>
    </mat-tab-group>
    <ngx-datatable *ngIf="renderTable" #myTable [ngClass]="{'disabledbutton': isToogle || isTooglePrestationEcoloc}"
      [ngStyle]="{'height': detail.lignesParSection ? 'calc(100% - 30px)' : '100%'}" class="material"
      [rows]="detail.lignesParSection ? selectedSection.ligneAffiche : detail.listLignes" [columnMode]="'force'"
      [headerHeight]="30" [footerHeight]="0" [rowHeight]="30" [selectionType]="'single'" (select)="onSelect($event)"
      [messages]="{emptyMessage: 'Pas de lignes à afficher'}" [loadingIndicator]="loadingIndicator"
      [selected]="selected" [dragulaName]="'bag'"
      [dragulaModel]="detail.lignesParSection ? selectedSection.ligneAffiche : detail.listLignes"
      (directiveDrop)="onDrop($event)" (directiveDrag)="onDrag($event)" [selectedrag]="selected">

      <ngx-datatable-row-detail [rowHeight]="75" #myDetailRow (toggle)="onDetailToggle($event)">
        <ng-template let-row="row" let-rowIndex="rowIndex" let-expanded="expanded" ngx-datatable-row-detail-template>
          <div class="col-sm-12" style="height: 100%">
            <app-detail-devis-supp [row]="row" [detail]="detail" [rowIndex]="rowIndex" [notModif]="true"
              (closefunction)="toggleExpandRow(row)" (saveDetailSuppFunction)="saveDetailSupp($event)"
              [listContenant]="listContenant" [listAgence]="listAgence" [isDroitModifDevis]="isDroitModifDevis">
            </app-detail-devis-supp>
          </div>
        </ng-template>
      </ngx-datatable-row-detail>

      <ngx-datatable-column *ngIf="isDroitModifDevis" [width]="40" [sortable]="false" [canAutoResize]="false">
        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row" let-value="value"
          let-isSelected="isSelected" let-onCheckboxChangeFn="onCheckboxChangeFn">
          <div class="selecticon" (click)="selectRow(row)" *ngIf="!row.dragstart">
            <i class="fa fa-ellipsis-v"></i>
            <i class="fa fa-ellipsis-v" style="margin-left: -2px"></i>
          </div>
          <div class="selecticon" *ngIf="row.dragstart">
            <i class="fa fa-arrows" aria-hidden="true"></i>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Libelle" prop="article.code" [width]="150">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader">
            <span class="uppercase"> Article </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div class="getID" id="{{rowIndex}}" (click)="selectRow(row, true)">
            <app-autocomplete [placeholder]="row.article ? '' : 'Article'"
              (searchfunction)="searchArticle($event, rowIndex)"
              (selectfunction)="row.showQteInput = true;setValue($event, row, rowIndex)" [notOblig]="true" [label]="''"
              [selectvalue]="true" [container]="true" [results]="dataArticle" [id]="classPresta + ' article' +rowIndex"
              [active]="detail.isHisto || !isDroitModifDevis" [defaultsearch]="value" [autohide]="true"
              [dropdownclass]="'dropetat'" [disablefocus]="true"
              (keyenterfunction)="row.showQteInput = true;focus_toQte(rowIndex)" [activeDropUp]="true"
              (blurfunction)="!detail.isHisto && isDroitModifDevis ? setValue(row.article, row, rowIndex, true) : false"></app-autocomplete>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Description" [width]="250">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader">
            <span class="uppercase">Description</span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div id="description{{rowIndex}}" [popover]="row.description||''" [container]="'body'"
            [containerClass]="'contenantPopoevr'" triggers="mouseenter:mouseleave mouseenter:click"
            (click)="selectRow(row, true)">
            <input type="text" class="input detailfact" id="description{{rowIndex}}" placeholder="Description"
              [(ngModel)]="row.description" (ngModelChange)="changeDescription()" autocomplete="off"
              (keydown.enter)="row.showQteInput = true;common.focusNext2ms('.ligneBon')"
              [disabled]="detail.isHisto || !isDroitModifDevis"
              (keydown.tab)="row.showQteInput = true;common.setVisibility('#quantite' + rowIndex)">
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Unite" prop="article.unite" [width]="90">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader text-center">
            <span class="uppercase"> U </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div class="strong text-center"
            *ngIf="(row.article && row.article.id && row.article.familleArticle && row.article.familleArticle.id !== 9)">
            {{ value || '' }}
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="quantite" [width]="120">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader">
            <span class="uppercase  text-center"> qté </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div id="qte{{rowIndex}}" (click)="selectRow(row, true)"
            *ngIf="(row.article && row.article.id && row.article.familleArticle && row.article.familleArticle.id !== 9)">
            <input type="text" *ngIf="row.article && row.article.id && row.showQteInput" id="quantite{{rowIndex}}"
              class="input detailfact text-right" placeholder="qté" (click)="focus($event)" [(ngModel)]="row.quantite"
              focusAll (ngModelChange)="calculMontant(row)" (blur)="row.showQteInput = false;getPrix();"
              autocomplete="off" (keydown.enter)="keyEnterTabQte(row);common.focusNext2ms('.ligneBon');"
              (keydown.tab)="keyEnterTabQte(row);common.setVisibility((societe.gestionFIP ? '#qteAN' : '#pu') + rowIndex);"
              [disabled]="detail.isHisto || !isDroitModifDevis">
            <div *ngIf="row.article && row.article.id && !row.showQteInput" class="col-sm-12 p-0 text-right"
              [ngClass]="{'disabledbutton': detail.isHisto || !isDroitModifDevis}" style="cursor: text;"
              (click)="row.showQteInput = true;common.setVisibility('#quantite' + rowIndex);"> {{(value ?
              value : default.toFixed(nbdigit)) | currency:'':'':'1.0-8'}}</div>
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="quantiteAnnuelle" *ngIf="societe.gestionFIP" [width]="120">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader">
            <span class="uppercase  text-center"> QTE AN </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div id="qte{{rowIndex}}" (click)="selectRow(row, true)"
            *ngIf="(row.article && row.article.id && row.article.familleArticle && row.article.familleArticle.id !== 9)">
            <input type="text" *ngIf="row.article && row.article.id && row.showQteANInput" id="qteAN{{rowIndex}}"
              class="input detailfact text-right" placeholder="qté" (click)="focus($event)" [(ngModel)]="row.quantiteAnnuelle"
              focusAll (ngModelChange)="calculMontant(row)" (blur)="row.showQteANInput = false;getPrix();"
              autocomplete="off" (keydown.enter)="row.showPUInput = true;common.focusNext2ms('.ligneBon');"
              (keydown.tab)="row.showPUInput = true;common.setVisibility('#pu' + rowIndex);"
              [disabled]="detail.isHisto || !isDroitModifDevis">
            <div *ngIf="row.article && row.article.id && !row.showQteANInput" class="col-sm-12 p-0 text-right"
              [ngClass]="{'disabledbutton': detail.isHisto || !isDroitModifDevis}" style="cursor: text;"
              (click)="row.showQteANInput = true;common.setVisibility('#qteAN' + rowIndex);"> {{(value ?
              value : default.toFixed(nbdigit)) | currency:'':'':'1.0-8'}}</div>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Tarif" prop="tarif" [width]="140">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader">
            <span class="uppercase  text-center"> Tarif </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div id="tarif{{rowIndex}}" (click)="selectRow(row, true)"
            *ngIf="(row.article && row.article.id && row.article.familleArticle && row.article.familleArticle.id !== 9)">
            <input type="text" *ngIf="row.article && row.article.id && row.showPUInput" id="pu{{rowIndex}}" focusAll
              class="input detailfact text-right" placeholder="prix unitaire" (click)="focus($event)"
              [(ngModel)]="row.tarif" (ngModelChange)="calculMontant(row)"
              (blur)="row.showPUInput = false;checkPrixMinMax(row);" autocomplete="off"
              (keydown.enter)="common.focusNext('.ligneBon')" [disabled]="detail.isHisto || !isDroitModifDevis">
            <div *ngIf="row.article && row.article.id && !row.showPUInput" class="col-sm-12 p-0 text-right"
              [ngClass]="{'disabledbutton': detail.isHisto || !isDroitModifDevis}" style="cursor: text;"
              (click)="row.showPUInput = true;common.setVisibility('#pu' + rowIndex);"> {{(value ?
              value : default.toFixed(nbdigit)) | currency:'':''}}</div>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="TxTVA" prop="txTVA" [width]="100">
        <ng-template let-col="column" ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
          let-selectFn="selectFn" let-sort="sortFn">
          <div class="tableheader">
            <span class="uppercase  text-center">TVA</span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div class="strong  text-right"
            *ngIf="(row.article && row.article.id && row.article.familleArticle && row.article.familleArticle.id !== 9)">
            {{row.article.id ?
            (row.article.tva || value || 0) : (value || 0)}} </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="MontantHT" prop="montantHT" [width]="160">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader">
            <span class="uppercase  text-center"> HT </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div class="strong text-right"
            *ngIf="(row.article && row.article.id && row.article.familleArticle && row.article.familleArticle.id !== 9)">
            {{(value ?
            value.toFixed(nbdigit) : default.toFixed(nbdigit)) | currency:'':''}} </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [width]="60" [sortable]="false" [canAutoResize]="false" [draggable]="false">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader screensize text-center">
            <span class="uppercase"> accept</span>
          </div>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
          <div class="text-center"
            *ngIf='detail.isHisto || (row.article && row.article.id &&  row.article.familleArticle && row.article.familleArticle.id !== 9)'
            [ngClass]="{'disabledbutton': detail.isHisto || (!row.article || (row.article && !row.article.id))}">
            <i *ngIf="row.accept" class="fa  fa-check-circle" aria-hidden="true"
              style="color: #299c73; font-size: 22px;" (click)="row.accept = !row.accept; changeDescription();"></i>

            <i *ngIf="!row.accept" class="fa  fa-circle" aria-hidden="true" [ngClass]="{'disabledbutton': societe.gestionFIP && ((row.fipDD && row.fipDD.id && !row.fipDD.signee) || (row.fipDND && row.fipDND.id && !row.fipDND.signee)) }"
              (click)="row.accept = !row.accept; changeDescription();" style="color: #e7e7e7; font-size: 22px;"></i>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="MontantHT" prop="pourcentageRemise" [width]="140">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader">
            <span class="uppercase  text-center"> % Rem </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div id="rem{{rowIndex}}" (click)="selectRow(row, true)"
            *ngIf="(row.article && row.article.id && row.article.familleArticle && row.article.familleArticle.id !== 9)">
            <input type="text" *ngIf="row.article && row.article.id" id="rem{{rowIndex}}"
              class="input detailfact text-right" placeholder="% Rem" (click)="focus($event)"
              [(ngModel)]="row.pourcentageRemise" (ngModelChange)="calculMontantAvecRem(row)" autocomplete="off"
              (keydown.enter)="common.focusNext('.ligneBon')" [disabled]="detail.isHisto || !isDroitModifDevis">
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="MontantHT" prop="montantHT" [width]="170">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader">
            <span class="uppercase  text-center"> Début </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div
            [ngClass]="{'disabledbutton': detail.isHisto  || (row.article && row.article.id && row.article.familleArticle && row.article.familleArticle.id === 9) }">
            <app-input-date [dateVide]="true" [class]="'form-control input-simple debut4 detailfact'"
              [id]="'dateDebut' + rowIndex" [model]="row.dateDebutModel" [closeDatepickerOnSelect]="true"
              [showDatepicker]="true" (changefct)="changeDate($event, row, 'dateDebut')" [position]="'bottom-right'"
              [disable]="!isDroitModifDevis" [notclickOutside]="true"></app-input-date>
          </div>


        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="MontantHT" prop="pourcentageRemise" [width]="170">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader">
            <span class="uppercase  text-center"> Fin </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div
            [ngClass]="{'disabledbutton': detail.isHisto  || (row.article && row.article.id && row.article.familleArticle && row.article.familleArticle.id === 9) }">
            <app-input-date [dateVide]="true" [class]="'form-control input-simple detailfact'"
              [id]="'dateFin' + rowIndex" [model]="row.dateFinModel" [closeDatepickerOnSelect]="true"
              [showDatepicker]="true" (changefct)="changeDate($event, row, 'dateFin')" [position]="'bottom-right'"
              [disable]="!isDroitModifDevis" [notclickOutside]="true"></app-input-date>
          </div>

        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column>
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader">
            <span class="uppercase"> Art Cont. </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div id="artcont{{rowIndex}}" (click)="selectRow(row, true)"
            *ngIf="(row.article && row.article.id && row.article.familleArticle && row.article.familleArticle.id !== 9)">
            <app-autocomplete [placeholder]="row.articleContenantContenu ? '' : 'Art cont'"
              (searchfunction)="searchArticleContenu($event, rowIndex)"
              (selectfunction)="isEdit=true; getdetailArticleContenu(row,$event,rowIndex);"
              [notOblig]="true" [label]="''" [selectvalue]="true" [container]="true" [results]="artContenu"
              [id]="classPresta + ' artCont' + rowIndex" [active]="detail.isHisto || !isDroitModifDevis"
              [autohide]="true" [dropdownclass]="'dropetat'" [disablefocus]="true" [disablefocus]="true"
              (keyenterfunction)="common.focusNext('.ligneBon')" [defaultsearch]="row.articleContenantContenu && row.articleContenantContenu.id ?
                                (row.articleContenantContenu.libelle || row.articleContenantContenu.libelleObjetEntite) :
                                'Tous'">
            </app-autocomplete>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column>
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader">
            <span class="uppercase"> Chantier </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div id="chantier{{rowIndex}}" (click)="selectRow(row, true)"
            *ngIf="(row.article && row.article.id && row.article.familleArticle && row.article.familleArticle.id !== 9)"
            [ngClass]="{'disabledbutton': row.agence && row.agence.id > 0}">
            <app-autocomplete [placeholder]="row.chantier ? '' : 'Chantier'" (searchfunction)="searchChantier($event)"
              (selectfunction)="isEdit=true; row.chantier = $event;" [notOblig]="true" [label]="''" [selectvalue]="true"
              [positionDropdown]="'rightDatatable'" [container]="true" [results]="listChantier"
              [id]="classPresta +  ' chantier'" [active]="detail.isHisto || !isDroitModifDevis" [autohide]="true"
              [deleteSelectedValue]="true" [dropdownclass]="'dropetat'" [showResultKeyenter]="true"
              [disablefocus]="true" (keyenterfunction)="common.focusNext('.ligneBon')"
              [defaultsearch]=" row.agence && row.agence.id > 0  ? 'Aucun' : row.chantier  ? getLibelleChantier(row.chantier) : '' ">
            </app-autocomplete>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [width]="60" [sortable]="false" [canAutoResize]="false" [draggable]="false"
        [resizeable]="false">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader screensize text-center" (click)="fullTable()">
            <i *ngIf="!viewFull" class="fa fa-arrows-alt" aria-hidden="true"></i>
            <i *ngIf="viewFull" class="fa fa-compress" aria-hidden="true" style="font-size: 16px;"></i>
          </div>
        </ng-template>
        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
          <button class="btn-detail" (click)="toggleExpandRow(row); selectRow(row, true)"
            popover="Voir les détails supplémentaires" [container]="'body'" [notDebounce]="true"
            [containerClass]="'contenantPopoevr'" triggers="mouseenter:mouseleave mouseenter:click">
            <i class="fa fa-search"></i>
          </button>
          <button *ngIf="isDroitModifDevis" class="btn-detail" (click)="deleteLigne(row)">
            <i class="fa fa-trash"></i>
          </button>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>

  <div class="addLigne col-sm-12 uppercase" id="addLigne">
    <div class="foot">
      <div class="col-sm-7 text-left" [ngStyle]="{'padding-top': showPied ? '12px' : '5px'}">
        <button *ngIf="!detail.isHisto && isDroitModifDevis" class="btn-add" (click)="addLigne()">
          <i class="fa fa-plus"></i>
        </button>
        <span (click)="addLigne()" *ngIf="!detail.isHisto && isDroitModifDevis">Ajouter une ligne</span>

        <button *ngIf="!detail.isHisto && isDroitModifDevis" class="btn-add" style="margin-left: 20px;"
          (click)="inserteLigne()">
          <img src="assets/images/icons/add-column.png" />
        </button>
        <span (click)="inserteLigne()" *ngIf="!detail.isHisto && isDroitModifDevis">Insérer une ligne</span>
      </div>

      <div class="text-right col-sm-5" style="padding: 0">
        <div class="pied col-sm-12" *ngIf="showPied">
          <div class="form-group col-sm-12" style="padding: 0" *ngIf="detail.montantHT">
            <label class="col-sm-8 col-form-label"> Montant HT : </label>
            <label class="col-sm-4 col-form-label text-right"> {{(detail.montantHT ?
              detail.montantHT.toFixed(nbdigit) : default.toFixed(nbdigit)) | currency:'':''}} {{ devise }}
            </label>
          </div>
          <div class="form-group col-sm-12" style="padding: 0" *ngIf="detail.pourcentageRemise">
            <label class="col-sm-8 col-form-label"> Remise : </label>
            <label class="col-sm-4 col-form-label text-right"> {{(detail.pourcentageRemise ?
              toFixed(detail.montantRemise) : default.toFixed(nbdigit)) | currency:'':''}} {{
              detail.pourcentageRemiseEuro ? devise : '%'
              }} </label>
          </div>
          <div class="form-group col-sm-12" style="padding: 0" *ngFor="let item of detail.listTVA">
            <label class="col-sm-8 col-form-label" *ngIf="item.montant"> Montant TVA {{item.tva.taux}} :
            </label>
            <label class="col-sm-4 col-form-label text-right" *ngIf="item.montant"> {{(item.montant ?
              item.montant.toFixed(nbdigit) : default.toFixed(nbdigit)) | currency:'':''}} {{ devise }} </label>
          </div>
        </div>
        <div class="col-sm-12" style="color: #000000; font-size: 18px;padding: 0;">
          <div class="col-sm-12" style="padding: 0">
            <strong class="col-sm-8 col-form-label"> Montant TTC : </strong>
            <span class="col-sm-4 col-form-label text-right"> {{(detail.montantTTC ?
              detail.montantTTC.toFixed(nbdigit) : default.toFixed(nbdigit)) | currency:'':'' }} {{ devise
              }} </span>
          </div>

        </div>
        <label class=" uppercase text-underline historique " (click)="showPied = !showPied;">Voir le détail du
          pied</label>
      </div>
    </div>
  </div>
</div>
<app-empty-detail-devis *ngIf="isEmpty"></app-empty-detail-devis>

<div class="ficheIn_devis" #fiche id="fiche" [ngStyle]="{'width': showcht || showContact || prixNego ? '100%' : '0'}">
  <div class="ficheclt" *ngIf="isEditCht" style="padding: 0; height: calc(100% + 5px); width: 550px; margin-top: -5px;">
    <app-fiche-chantier [chantier]="chantier" [client]="client" [hideDetenteur]="true" [edit]="chantier.id"
      (hidefunction)="closeCht();" [prospectHolding]="client.prospectHolding || false">
    </app-fiche-chantier>
  </div>
  <div class="ficheclt" *ngIf="createCht"
    style="padding: 0;  height: calc(100% + 5px); width: 550px; margin-top: -5px;">
    <app-fiche-chantier [chantier]="chantier" [client]="client" [hideDetenteur]="true" (hidefunction)="closeCht();"
      [edit]="true" [prospectHolding]="client.prospectHolding || false" (addfunction)="createChantier($event)"
      [add]="true">
    </app-fiche-chantier>
  </div>
  <div class="ficheclt" *ngIf="showContact"
    style="padding: 0;  height: calc(100% + 5px); width: 550px; margin-top: -5px;">
    <app-fiche-contact [contact]="!isAddContact ? detail.contact : {}" [client]="detail.client"
      (hidefunction)="showFicheContact();" [edit]="true" (addfunction)="createChantier($event)" [add]="isAddContact"
      (aftersave)="reloadContact($event)"></app-fiche-contact>
  </div>
  <div class="ficheclt" *ngIf="prixNego"
    style="padding: 0;  height: calc(100% + 5px); width: 100%;    background-color: #fff;">
    <app-prix-negocies [detail]="detail.client" (show)="prixNego = !prixNego;" [depuisDevis]="true"
      (insertDevis)="insertDevisFct($event)">
    </app-prix-negocies>
  </div>
</div>

<div *ngIf="isToogle">
  <app-create-mvt-devis (observerMvtCreated)="handleBtnTerminerCreationMvt($event)" (close)="toogleSlide()"
    [info]="infoContenant" [addContenant]="true"></app-create-mvt-devis>
</div>

<div class="slide-prestation" *ngIf="isTooglePrestationEcoloc"
  [ngStyle]="{'width': isTooglePrestationEcoloc ? '100%' : '0px'}">
  <app-create-prestation [planning]="planning" [selectedEvent]="{}" [eventSelected]="{}" [moduleSource]="'ecocrm'"
    [isEdit]="false" (closefct)="closeCreatePrestationDevis()" (reinitfct)="reinitPrestationDevis()"
    (rafraichir)="actualiserCreatePrestationDevis()">
  </app-create-prestation>
</div>

<ng-template #format>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Choix du format </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <ul class="list-group listeformat" *ngIf="formatPerso.length">
        <li class="list-group-item" *ngFor="let item of formatPerso" (click)="formatprs = item"
          [ngClass]="{'formatselected': formatprs.id === item.id}">
          {{ item.libelleObjetEntite }}
        </li>
      </ul>

      <span *ngIf="!formatPerso.length"> Aucun format disponible. Veuillez en définir au moins un </span>

    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" *ngIf="!formatPerso.length" (click)="common.closeModal()">
        Fermer
      </button>
      <button type="button" class=" btn-close btn-valider" *ngIf="formatPerso.length"
        (click)="common.closeModal();handleBtnChoixFormat()">
        Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal()"> Annuler</button>
    </div>
  </div>
</ng-template>

<ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> {{ error }} </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal();"> Fermer</button>
    </div>
  </div>
</ng-template>

<ng-template #msgMail>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> {{ error }} </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <!-- <button type="button" class=" btn-close btn-valider" (click)="common.closeModal();  accepterDevis(null, 3)"> -->
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal();  etapeSuivantApresDepot()">
        Fermer
      </button>
    </div>
  </div>
</ng-template>

<ng-template #msgMailCR>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> {{ error }} </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal();  etapeSuivantApresDepot()">
        Fermer
      </button>
    </div>
  </div>
</ng-template>

<ng-template #dialogueDupliquer>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Confirmation </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12" style="margin-bottom: 5px;">
        <label class="cofirmemsg"> Choix du client</label>
      </div>
      <div class="col-sm-12" style="margin-bottom: 5px;">
        <app-recherche-multiple [placeholder]="'Nom et code client'" [minlength]="2" id="validationsearchdupliquer"
          [filtre]="searchTable" (selectfunction)="handleDupClientSelected($event)" [isclient]="true" [type]="9"
          [afficherClientToutProspect]="true" (setdefaultfiltre)="common.setValueFiltre($event)" [defaultsearch]=""
          #searchClientDupliquer>
        </app-recherche-multiple>
      </div>
    </div>
    <div class="col-sm-12 p-0 d-flex">
      <div class="col-sm-6 p-0 text-left">
        <label class="textlabel text-left uppercase text-underline" (click)="createClient()"> Voulez vous créer un prospect ? </label>
      </div>
      <div class="col-sm-6 p-0 d-flex text-right">
        <button type="button" class=" btn-close btn-valider mr-1" (click)="dupliquerDevis($event)"
          [disabled]="!dupClientSelected">
          Valider
        </button>
        <button type="button" class=" btn-close" (click)="common.closeModal()"> Annuler</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #dialogueDmdMotifRefus>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Séléction du motif </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12" style="margin-bottom: 5px;">
        <label class="cofirmemsg"> Veuillez choisir le motif de refus</label>
      </div>
      <div class="col-sm-12" style="margin-bottom: 5px;">
        <select class="form-control select" name="listeMotifRefusDevis" [(ngModel)]="detail.motifRefus">
          <option *ngFor="let item of listeMotifRefusDevis" [ngValue]="item"> {{item.libelle}} </option>
        </select>
      </div>
      <div class="col-sm-12 text-right">
        <button type="button" class=" btn-close btn-valider" (click)="historiserDevis(detail)"
          [disabled]="listeMotifRefusDevis.length == 0">
          Valider
        </button>
        <button type="button" class=" btn-close" (click)="common.closeModal()"> Annuler</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #dialoguePrixNego>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Prix négocié </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12" style="margin-bottom: 5px;">
        <label class="cofirmemsg"> Le tarif {{ article_prix_nego }} correspond à un prix liste. Souhaitez-vous
          créer un prix négociée ?</label>
      </div>
    </div>
    <div class="col-sm-12 text-right">
      <button type="button" class=" btn-close btn-valider" (click)="repondreDialoguePrixNego(true)">
        Oui
      </button>
      <button type="button" class=" btn-close" (click)="repondreDialoguePrixNego(false)"> Non</button>
    </div>
  </div>
</ng-template>

<ng-template #dialoguePNZero>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Prix négocié </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12" style="margin-bottom: 5px;">
        <label class="cofirmemsg"> Le devis contient des tarifs 0 souhaitez vous les transformer en prix
          négociés ?</label>
      </div>
    </div>
    <div class="col-sm-12 text-right">
      <button type="button" class=" btn-close btn-valider" (click)="repondreDialoguePNZero(true)">
        Oui
      </button>
      <button type="button" class=" btn-close" (click)="repondreDialoguePNZero(false)"> Non</button>
    </div>
  </div>
</ng-template>

<ng-template #dialogueCodeClient>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Code client </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12" style="margin-bottom: 5px;">
        <label class="cofirmemsg"> Code du client ?</label>
      </div>
      <div class="col-sm-12" style="margin-bottom: 5px;">
        <input type="text" class="form-control" id="codeClient" [(ngModel)]="devis.client.codeClient">
      </div>
    </div>
    <div class="col-sm-12 text-right">
      <button type="button" class=" btn-close btn-valider" (click)="repondreCodeClient()">
        Valider
      </button>
    </div>
  </div>
</ng-template>

<ng-template #visibilite>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Visibilité du client : </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modalFicheClient" style="height: auto">
    <div class="col-sm-12" style="padding: 0px;">
      <div class="form-group items col-sm-12">
        <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
          [(ngModel)]="visibiliteValue" (ngModelChange)="changeVisibilite(visibiliteValue)">
          <mat-radio-button [color]="'primary'" class="example-radio-button" *ngFor="let item of choixVisibilite"
            [value]="item.id">
            {{item.libelle}}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <label class="titre">Modules</label>
      <div class="form-group items col-sm-12 module">
        <div class="col-sm-6" *ngFor="let item of listModules">
          <mat-checkbox [color]="'primary'" [disabled]="visibiliteValue !== 3" [(ngModel)]="item.checked">
            {{ item.libelle }} </mat-checkbox>
        </div>
      </div>

    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button type="button" class=" btn-close btn-valider" (click)="validerVisibilite();common.closeModal();">
        Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal(); validerDevis(devis)"> Annuler
      </button>
    </div>
  </div>
</ng-template>

<ng-template #confirmeAccepteDevis>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Confirmation </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12" style="margin-bottom: 5px;">
        <label class="cofirmemsg"> Etes vous sur de vouloir accepter ce devis ?
          Cette action va créer les prix négociés associés. </label>
      </div>
    </div>
    <div class="col-sm-12 text-right">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal();accepterDevis(detail, -1)">
        Oui
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal()"> Non</button>
    </div>
  </div>
</ng-template>

<ng-template #dialogueLibelleNego>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Choix des libellés negociés à créer : </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modalFicheClient" style="height: auto">
    <div class="col-sm-12" style="margin-bottom: 5px; padding-left: 0px">
      <label class="cofirmemsg"> Choix des lignes</label>
    </div>
    <div class="col-sm-12" style="padding: 0px;">
      <ngx-datatable *ngIf="renderTable" style="height: 100%" class="material" [rows]="listLibelleNegocier"
        [columnMode]="'force'" [headerHeight]="35" [footerHeight]="0" [rowHeight]="30" [selectionType]="'checkbox'"
        [messages]="{emptyMessage: loadingIndicator ? 'Chargement ...' : 'Pas de lignes à afficher'}"
        [loadingIndicator]="loadingIndicator" [selected]="selected">

        <ngx-datatable-column prop="description" [cellClass]="getCellClass">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Description </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            {{value}}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [width]="50" [sortable]="false" [canAutoResize]="false" [draggable]="false"
          [resizeable]="false">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn">
            <div style='top: -5px;position: relative;'>
              <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                [(ngModel)]="checkedall" (ngModelChange)="checkedAll($event)"
                [ngClass]="{'regular-checkbox-checked': checkedall}" />
            </div>
          </ng-template>
          <ng-template ngx-datatable-cell-template let-row="row">
            <input type="checkbox" id="checkbox-1-1" class="regular-checkbox" (change)="checked(row)"
              [(ngModel)]="row.createLibelleNegocie"
              [ngClass]="{'regular-checkbox-checked': row.createLibelleNegocie}" />
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>

    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal(); validerLibelleNego()">
        Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal(); annulerLibelleNego()"> Annuler
      </button>
    </div>
  </div>
</ng-template>

<ng-template #dialogueNbBenne>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Nombre de benne </h4>
    <!-- <h4 class="modal-title pull-left"> Nombre de benne ({{ descriptionDialogueNbBenne }}) </h4> -->
    <button type="button" class="close pull-right" aria-label="Close"
      (click)="common.closeModal(); passerSurLaLigneSuivanteDuDevis();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12" style="margin-bottom: 5px;">
        <label class="col-sm-12 champ" style="padding:0px"> Combien de bennes voulez-vous déposer ?</label>
        <div class="col-sm-12 champ disabledbutton" style="padding: 0px">
          <input type="text" class="form-control" [(ngModel)]="nbBennes">
        </div>
      </div>
    </div>
    <div class="col-sm-12 text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="whileNbBenneCreateMvt(indexNbBenneCreateMvt)">
        Ok
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal(); passerSurLaLigneSuivanteDuDevis();">
        Annuler
      </button>
    </div>
  </div>
</ng-template>

<ng-template #testCreationMouvement>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Test création mouvement </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12" style="margin-bottom: 5px;">
        <label class="cofirmemsg"> Création mvt du benne n°{{ indexNbBenneCreateMvt }} Ligne n°
          {{ indexLigneDevisCreateMvt }} </label>
      </div>
    </div>
    <div class="col-sm-12 text-right">
      <button type="button" class=" btn-close btn-valider" (click)="handleBtnTerminerCreationMvt()">
        Oui
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal()"> Non</button>
    </div>
  </div>
</ng-template>

<ng-template #mail>
  <app-panneau-mail [data]="datamail" (validerPanneauMail)="validerPanneauMail($event)" [aUnSignature]="aUnSignature"
    [showPJ]="true" (annulerPanneauMail)="annulerPanneauMail()">
  </app-panneau-mail>
</ng-template>

<ng-template #loading>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> Envoi en cours ... </label>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #formatCAP>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Choix du format </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <ul class="list-group listeformat" *ngIf="formatPersoCAP.length">
        <li class="list-group-item" *ngFor="let item of formatPersoCAP" (click)="formatprsCAP = item"
          [ngClass]="{'formatselected': formatprsCAP.id === item.id}">
          {{ item.libelleObjetEntite }}
        </li>
      </ul>

      <span *ngIf="!formatPersoCAP.length"> Aucun format disponible. Veuillez en définir au moins un </span>

    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" *ngIf="!formatPersoCAP.length" (click)="common.closeModal()">
        Fermer
      </button>
      <button type="button" class=" btn-close btn-valider" *ngIf="formatPersoCAP.length"
        (click)="common.closeModal();printCAP(true)">
        Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal()"> Annuler</button>
    </div>
  </div>
</ng-template>

<ng-template #codeClientProspect>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Code client </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12" style="margin-bottom: 5px;">
        <label class="cofirmemsg"> Saisissez le code du client</label>
      </div>
      <div class="col-sm-12" style="margin-bottom: 5px;">
        <input type="text" class="form-control" id="date" [(ngModel)]="objProspect.code">
      </div>
    </div>
    <div class="col-sm-12 text-right">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal();validerProspect()">
        Valider
      </button>
    </div>
  </div>
</ng-template>

<ng-template #CRMail>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Envoi par mail de CR </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12" style="margin-bottom: 5px;">
        <label class="cofirmemsg"> Souhaitez vous envoyer un compte rendu des dépots par mail au client ?
        </label>
      </div>
    </div>
    <div class="col-sm-12 text-right">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal();ouiMail();">
        Oui
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal();nonMail();"> Non</button>
    </div>
  </div>
</ng-template>

<ng-template #dialoguePrestationEcoloc>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Validation devis </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12" style="margin-bottom: 5px;">
        <label class="cofirmemsg"> Souhaitez vous créer un bon par prestation ?</label>
      </div>
    </div>
    <div class="col-sm-12 text-right">
      <button type="button" class=" btn-close btn-valider" (click)="repondreDialoguePrestationEcoloc(true)">
        Oui
      </button>
      <button type="button" class=" btn-close" (click)="repondreDialoguePrestationEcoloc(false)"> Non</button>
    </div>
  </div>
</ng-template>

<div class="spinner" id="spinnerCont" *ngIf="isClick">
  <div class="sk-fading-circle">
    <div class="sk-circle1 sk-circle"></div>
    <div class="sk-circle2 sk-circle"></div>
    <div class="sk-circle3 sk-circle"></div>
    <div class="sk-circle4 sk-circle"></div>
    <div class="sk-circle5 sk-circle"></div>
    <div class="sk-circle6 sk-circle"></div>
    <div class="sk-circle7 sk-circle"></div>
    <div class="sk-circle8 sk-circle"></div>
    <div class="sk-circle9 sk-circle"></div>
    <div class="sk-circle10 sk-circle"></div>
    <div class="sk-circle11 sk-circle"></div>
    <div class="sk-circle12 sk-circle"></div>
  </div>
</div>

<ng-template #gestFIP>
  <div class="modal-body moduleEcobennes" style="height: 450px; padding: 0px 10px;">
    <app-gestion-fip [detail]="{}" (show)="common.closeModal(); nextFIPClose();" [isDevis]="true"
      [pasFicheClient]="true" [bon]="devisFIP" [retourFIPDevis]="listFIP" [isDD]="isDD"></app-gestion-fip>
  </div>
</ng-template>

<ng-template #formatPesroFIP>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Choix du format </h4>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <ul class="list-group listeformat" *ngIf="formatPerso.length">
        <li class="list-group-item" *ngFor="let item of formatPerso" (click)="formatprs = item"
          [ngClass]="{'formatselected': formatprs.id === item.id}">
          {{ item.libelleObjetEntite }}
        </li>
      </ul>
      <span *ngIf="!formatPerso.length"> Aucun format disponible. Veuillez en définir au moins un </span>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" *ngIf="!formatPerso.length"
        (click)="common.closeModal(); nextClose();">
        Fermer
      </button>
      <button type="button" class=" btn-close btn-valider" *ngIf="formatPerso.length"
        (click)="common.closeModal();printFIP();">
        Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal(); nextClose();"> Annuler</button>
    </div>
  </div>
</ng-template>

<ng-template #formatPesroFIPMail>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Choix du format {{typeFIP === 37 ? 'DND' : 'DD'}} </h4>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <ul class="list-group listeformat" *ngIf="formatPerso.length">
        <li class="list-group-item" *ngFor="let item of formatPerso" (click)="selectFPFipMail(item)"
          [ngClass]="{'formatselected': ((typeFIP === 37 && selectedFpFIP.dnd && selectedFpFIP.dnd.id === item.id) || (typeFIP === 38 && selectedFpFIP.dd && selectedFpFIP.dd.id === item.id))}">
          {{ item.libelleObjetEntite }}
        </li>
      </ul>
      <span *ngIf="!formatPerso.length"> Aucun format disponible. Veuillez en définir au moins un </span>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" *ngIf="!formatPerso.length" (click)="common.closeModal();">
        Fermer
      </button>
      <button type="button" class=" btn-close btn-valider" *ngIf="formatPerso.length"
        (click)="common.closeModal();envoieMailFIP();">
        Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal();"> Annuler</button>
    </div>
  </div>
</ng-template>

<ng-template #confirmaFIPDND>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Impresion FIP DND : </h4>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> Souhaitez vous imprimer une FIP pour les DND ? </label>
      </div>
    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal(); avantAppelFormatPersoDND();">
        OUI
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal(); nextClose();"> NON</button>
    </div>
  </div>
</ng-template>

<ng-template #confirmaFIPDD>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Impresion FIP DD : </h4>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> Souhaitez vous imprimer une FIP pour les DD ? </label>
      </div>
    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal();avantAppelFormatPersoDD();">
        OUI
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal();nextClose();"> NON</button>
    </div>
  </div>
</ng-template>



<div class="fiche" #ficheC id="fiche" [ngStyle]="{'width': showFicheclt ? '100%' : '0'}">
  <div class="col-sm-12 client"  *ngIf="showFicheclt">
    <app-fiche-client [client]="''" [objClient]="{}"
      (hidefunction)="closeCreateClt()" [add]="true"
      (addfunction)="afterAddClt($event)" [prospect]="true"></app-fiche-client>
  </div>
</div>


<ng-template #confirmeTousModule>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Sélection des modules : </h4>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> Souhaitez-vous sélectionner tous les modules ? </label>
      </div>
    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal(); accepterToutsModules();">
        OUI
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal(); refuserToutsModules();"> NON</button>
    </div>
  </div>
</ng-template>
